import React from "react";
import { useState, useEffect } from "react";
import { IonPage, IonContent } from '@ionic/react';
import './Profile.css';
import Footer from "../components/Footer";
import Header from "../components/Header";
import env from '../env.json'
import ReactGA from "react-ga4";
import axios from "axios";

// const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

// const getOrCreateGaClientIdForHome = (): string => {
//   let clientId = localStorage.getItem('ga_client_id');
//   if (!clientId) {
//     clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
//                self.crypto.randomUUID() : 
//                `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
//     localStorage.setItem('ga_client_id', clientId);
//   }
//   return clientId;
// };

// const user = localStorage.getItem('profile') as string;
// const profile = user ? JSON.parse(user) : null;
// const userIdForGa = profile?.id?.toString() ?? undefined; 

// const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//       page_location: '/pages/Profile',
//       page_title: 'Profile'
//   }
// };

// console.log('Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (page_view):', error);
// });

// ReactGA.send({ hitType: "pageview", page: "/pages/Profile", page_title: "Perfil" });

const Profile: React.FC = () => {

    const [fullname, setFullname] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [property, setProperty] = useState('');
    const [address, setAddress] = useState('');
    const [userType, setUserType] = useState('');
    const [pin, setPin] = useState(1234)

    const url = env.REACT_APP_URL;
    
    const token = localStorage.getItem('token');
    const header = {
        'Authorization': 'Bearer ' + token
    }
    
    /*-------------- Actualizar los datos del perfil -----------------*/

    const loadProfile = async () => {
        const token = localStorage.getItem('token');
        const header = {
            'Authorization': 'Bearer ' + token
        }

        const instance = axios.create({
            baseURL: url,
            headers: header
        })

        await instance.get('/api/profile')
        .then(res => {
            localStorage.setItem('profile', JSON.stringify(res.data));         
        })
    }

    const fillProfile = () => {
        let dataProfile = localStorage.getItem('profile');
        const profile = JSON.parse(dataProfile!)
        let full_address = profile.address ? profile.address : ''
        full_address = profile.address2 ? `${profile.address} / ${profile.address2}` : full_address
        full_address = profile.address3 ? `${full_address} / ${profile.address3}` : full_address
        setFullname(profile.full_name);
        setPhone(profile.phone);
        setEmail(profile.email);
        setProperty(profile.property ? profile.property.name : 'No Registra apartamento')
        setAddress(profile.address ? full_address : 'No Registra')
        setUserType(profile.type);
    }
    

    const updateProfile = () => {
        const instance = axios.create({
            baseURL: url,
            headers: header
        })

        instance.put('/api/profile', {
            full_name: fullname,
            email: email,
            phone: phone
        })
        .then(res => {
            alert('Actualizado');
            loadProfile();
        })
        .catch(e => {console.log(e)})
    }
    /*----------------------------------------------------------------*/
    useEffect( () => {
        loadProfile();
        fillProfile();
      }, []);

    return(
        <IonPage>
            <Header pageName="Perfil"/>
            <IonContent className="container data-profile">
                <div className="profile-form">
                    <input className="perfil-datos" type="text" placeholder="Nombre" value={fullname} onChange={event => setFullname(event.target.value)}/>
                    <input className="perfil-datos" type="text" placeholder="Célular" value={phone} onChange={event => setPhone(event.target.value)}/>
                    <input className="perfil-datos" type="text" placeholder="Tipo de usuario" value={userType} onChange={event => setUserType(event.target.value)}/>
                    <input className="perfil-datos" type="text" placeholder="Correo electrónico" value={email} onChange={event => setEmail(event.target.value)}/>
                    <input className="perfil-datos" type="text" placeholder="Apartamento" value={property} disabled/>
                    <input className="perfil-datos" type="text" placeholder="Dirección" value={address} disabled />
                    {/* <input className="perfil-datos" type="text" placeholder="PIN de sos" value={pin} disabled/> */}
                    <br />
                    <button className="btn btn-actualizar" onClick={updateProfile}>Actualizar</button>
                </div>
            </IonContent>
            <div className="footer-fix">
                <Footer />
            </div>  
        </IonPage>
    );
}

export default Profile;